<div class="ui basic segment" [class.loading]="isLoading">
    <app-header title="reporting.data-export.bulkDataExport" [back]="true"></app-header>

    <div class="ui segment" *permission="['create.file', 'export.employee']">
        <app-segment-header title="export"></app-segment-header>
        {{ 'reporting.data-export.clickBelowToDownloadTheExport' | translate }}
        <br />
        <br />
        <ui-button type="primary" style="float: left" (click)="onExport()">
            {{ 'reporting.data-export.downloadBulkExport' | translate }}
        </ui-button>
        <div class="clear"></div>
    </div>
</div>
